/*eslint-disable lodash/prefer-lodash-method*/

const data = window.SPM_CONFIG;

export const experiment = data.experiment;

if (experiment) {
  experiment.data.videos = (experiment.data.videos || []);
  experiment.data.screenshots = (experiment.data.screenshots || []);


  if (experiment.data.videos && experiment.data.videos.length) {
    experiment.data.video = experiment.data.videos[0];
  } else if ((!experiment.data.videos || !experiment.data.videos.length) && experiment.data.video && experiment.data.video.url) {
    experiment.data.videos = [ experiment.data.video ];
  }

  if (experiment.data.videos) {
    experiment.data.videos = experiment.data.videos.map((video) => {
      if (video.autoplay !== false) {
        video.autoplay = true;
      }

      return video;
    });
  }

  if (experiment.data.video) {
    if (experiment.data.video.autoplay !== false) {
      experiment.data.video.autoplay = true;
    }
  }

  if (experiment.data.sticky_header !== false) {
    experiment.data.sticky_header = true;
  }
}


let integr = data.experiment ? (data.experiment.integrations || []) : [];

if (data.experiment && !Array.isArray(data.experiment.integrations)) {
  integr = [].concat(integr.web || []).concat(integr.install || []).concat(integr.smart_banner || []);
}

export const integrations = integr.filter(({ is_active }) => is_active);



// WEBPACK FOOTER //
// ./src/data-stores/ExperimentStore.js